import React, { useContext, useMemo, useState } from 'react'
import { Field, Form, Formik, } from 'formik';
import RangeSlider from "react-range-slider-input";
import { getImages } from '../Common/const';
import { Link } from 'react-router-dom';

const FinanceCalculatorForm = ({image, price, priceFormatter, vehicleLocation, onPaymentChange}) => {
    const [priceFilterData, setPriceFilterData] = useState({ 'min': 0, 'max': 20, 'current_value': 9.25 });
    const [rangeData, setRangeData] = useState([0, 9.25]);
    const [loanTermData, setLoanTermData] = useState({ 'min': 0, 'max': 10, 'current_value': 10 });
    const [loanTermRange, setLoanTermRange] = useState([0, 10]);
    const calcMonthlyPayment = (principal = 0, annualRatePct = 0, termYears = 0) => {
        if (!principal || !termYears) return 0;

        const n = termYears * 12;                    // total payments
        const i = (annualRatePct / 100) / 12;        // monthly rate

        // Zero-interest loan?  Simple division.
        if (i === 0) return principal / n;

        const factor = Math.pow(1 + i, n);
        return principal * (i * factor) / (factor - 1);
    };
    const subtractedPrice = Math.round(price * 0.85); 
    return (
        <>
            <Formik
                initialValues={{
                    loan_amount: subtractedPrice ? subtractedPrice.toString() : '',
                    interest_rate: priceFilterData.current_value || '',
                    loan_term: loanTermData.current_value || '',
                }}
                onSubmit={async (values, { resetForm }) => {
                    console.log(values);
                    // resetForm();
                }}
            >
                {({ values, setFieldValue }) => {
                    const handleSliderChange = (value) => {
                        setRangeData(value);
                        setPriceFilterData((prev) => ({
                            ...prev,
                            current_value: value[1],
                        }));
                        setFieldValue('interest_rate', value[1]);
                    };

                    const handleTermSliderChange = (value) => {
                        setLoanTermRange(value);
                        setLoanTermData((prev) => ({
                            ...prev,
                            current_value: value[1],
                        }));
                        setFieldValue('loan_term', value[1]);
                    };

                    // Simple inline calculation
                    const principal = Number(values.loan_amount) || 0;
                    const annualRate = Number(values.interest_rate) || 0;
                    const termYears = Number(values.loan_term) || 0;

                    const totalMonths = termYears * 12;
                    const monthlyRate = annualRate / 100 / 12;
                    const payment =
                        monthlyRate === 0
                            ? principal / totalMonths || 0
                            : (principal * monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) /
                            (Math.pow(1 + monthlyRate, totalMonths) - 1);

                    const formattedPayment = isFinite(payment)
                        ? `$${payment.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}`
                        : '--';
                        if (onPaymentChange) onPaymentChange(formattedPayment);
                    return (
                        <Form className="finance-calculator-form" autoComplete="off" name="order-part-form">
                            <div className='row mx-70'>
                                <div className='col-lg-4 mb-4'>
                                    <div className='md-title text-uppercase mb-md-5 mb-4'>Finance Estimate <br />Calculator</div>
                                    <div className='form-group'>
                                        <div className='cs-label font-1em fw-bold mb-3'>Loan Amount</div>
                                        <Field name="loan_amount">
                                            {({ field, form }) => {
                                                const rawValue = field.value?.replace(/[^\d]/g, '') || ''; // Only digits
                                                const formattedValue = rawValue ? `$${Number(rawValue).toLocaleString()}` : '';

                                                return (
                                                    <input
                                                        type="text"
                                                        {...field}
                                                        className="pr-input-field w-100 text-start"
                                                        value={formattedValue}
                                                        onChange={(e) => {
                                                            const inputVal = e.target.value.replace(/[^\d]/g, ''); // Strip non-numeric
                                                            form.setFieldValue('loan_amount', inputVal);
                                                        }}
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </div>
                                </div>
                                <div className='col-lg-4 mb-4'>
                                    <div className='form-group mb-4'>
                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                            <div className='xs-title font-1em mb-0'>Interest Rate</div>
                                            <Field
                                                type="text"
                                                name="interest_rate"
                                                className="pr-input-field text-center w-150px"
                                                value={`${values.interest_rate}%`}
                                                readOnly
                                            />
                                        </div>
                                        <div className='price-range-slider'>
                                            <RangeSlider
                                                className="single-thumb"
                                                value={rangeData}
                                                onInput={handleSliderChange}
                                                thumbsDisabled={[true, false]}
                                                rangeSlideDisabled={true}
                                                min={priceFilterData.min}
                                                max={priceFilterData.max}
                                                step={0.05}
                                            />
                                            <div className='d-flex align-items-center justify-content-between pr-labels'>
                                                <div>{`${priceFilterData.min}%`}</div>
                                                <div>{`${priceFilterData.max}%`}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                            <div className='xs-title font-1em mb-0'>Loan Term</div>
                                            <Field
                                                type="text"
                                                name="interest_rate"
                                                className="pr-input-field text-center w-150px"
                                                value={`${values.loan_term} yr`}
                                                readOnly
                                            />
                                        </div>
                                        <div className='price-range-slider'>
                                            <RangeSlider
                                                className="single-thumb"
                                                value={loanTermRange}
                                                onInput={handleTermSliderChange}
                                                thumbsDisabled={[true, false]}
                                                rangeSlideDisabled={true}
                                                min={loanTermData.min}
                                                max={loanTermData.max}
                                            />
                                            <div className='d-flex align-items-center justify-content-between pr-labels'>
                                                <div>{`${loanTermData.min}yr`}</div>
                                                <div>{`${loanTermData.max}yr`}</div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='d-lg-none mt-3 mb-0'>
                                        <div className='xxs-title font-0-9em'>*Monthly payment of {formattedPayment} based on a purchase price of {priceFormatter(price, true)} with 15% down and {`${values.interest_rate}%`} APR financing for {values.loan_term*12} months. Best rates are available for credit scores of 700 and above. TT&L may also be financed. Not all applicants will qualify. Rates and terms are subject to change without notice.</div>
                                    </div> */}
                                </div>
                                <div className='col-lg-4 mb-3 overflow-hidden'>
                                    <div className='mb-3 emp-image'>
                                        <img src={image}/>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="xs-title">Estimated Monthly <br/>Payment</div>
                                        <div className="md-title font-2-5em">{formattedPayment}</div>
                                    </div>
                                </div>
                                <div className='col-lg-4 order-lg-2 pt-1'>
                                    <div className='row gx-md-4 gx-2'>
                                        <div className='col-6'>
                                            <Link to={vehicleLocation == "Austin, TX" ? '/applyforcredit-austin':'/applyforcredit-boerne'} onClick={() => window.scrollTo(0, 0)} className='btn-theme w-100 d-block text-black text-center vdp-apply-btn'>Apply Now</Link>
                                        </div>
                                        <div className='col-6'>
                                            <Link to="/financing" onClick={() => window.scrollTo(0, 0)} className='black-btn w-100 d-block text-white text-center vdp-learn-btn text-uppercase'>Learn More</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-8 mt-3 mt-lg-0'>
                                    <div className='xxs-title font-0-9em'>*Monthly payment of {formattedPayment} based on a purchase price of {priceFormatter(price, true)} with 15% down and {`${values.interest_rate}%`} APR financing for {values.loan_term*12} months. Best rates are available for credit scores of 700 and above. TT&L may also be financed. Not all applicants will qualify. Rates and terms are subject to change without notice.</div>
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </>
    )
}

export default FinanceCalculatorForm